
import { EmailTemplate } from '@/types/emailTemplates';

// Cache keys
export const SYSTEM_VARS_CACHE_KEY = 'system_variables_cache';

// Simple in-memory cache for templates
const templateCache = new Map<string, {
  template: EmailTemplate;
  timestamp: number;
}>();

// Cache expiration time (5 minutes)
const CACHE_TTL = 5 * 60 * 1000;

/**
 * Store a template in the cache
 */
export function setCachedTemplate(templateId: string, template: EmailTemplate): void {
  templateCache.set(templateId, {
    template,
    timestamp: Date.now()
  });
}

/**
 * Get a template from the cache if it exists and hasn't expired
 */
export function getCachedTemplate(templateId: string): EmailTemplate | null {
  const cached = templateCache.get(templateId);
  
  if (!cached) {
    return null;
  }
  
  // Check if cache has expired
  if (Date.now() - cached.timestamp > CACHE_TTL) {
    templateCache.delete(templateId);
    return null;
  }
  
  return cached.template;
}

/**
 * Clear a specific template from the cache
 */
export function clearCachedTemplate(templateId: string): void {
  templateCache.delete(templateId);
}

/**
 * Clear the entire template cache
 */
export function clearTemplateCache(): void {
  templateCache.clear();
}
